'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';


import Image from '@eliadmin/core/src/components/image/image-wrapped';

import type { Blog } from '@eliadmin/core/src/api/blogs/blogs-types';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Paragraph } from '../ui/paragraph';
import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';
import { PageBreadcrumbs } from '../ui/page-breadcrumbs';

export function BlogBanner({ blog }: { blog: Blog }) {
  const locale = useLocaleStore(state => state.currentLocale);

  let formattedDate;

  try {
    formattedDate = new Date(blog.created_at).toLocaleDateString(locale);
  } catch (error) {
    if (error instanceof RangeError) {
      formattedDate = new Date(blog.created_at).toLocaleDateString('en-US');
    } else {
      throw error;
    }
  }

  return (
    <>
      <PageBreadcrumbs name={blog.name} />
      <section
        className={cn('custom-section', 'w-full pb-8 pt-4 sm:pb-12 sm:pt-6 lg:pb-16 lg:pt-8 xl:pb-[72px]')}
      >
        <div
          className={cn(
            'w-full max-w-[1728px]',
            'relative flex h-[420px] items-end justify-start overflow-hidden rounded-[24px] px-4 py-6 sm:h-[460px] sm:p-8 md:p-16 lg:h-[500px] lg:p-20 xl:p-24',
          )}
        >
          <div className="relative z-10 flex w-full flex-col items-start justify-start gap-4">
            <div className="flex items-center justify-start gap-4">
              <span className="flex h-[29px] items-center justify-center rounded-full bg-white px-4 text-xs font-medium">
                {blog.categories[0].name}
              </span>
              <Paragraph className="text-white">{formattedDate}</Paragraph>
            </div>
            <h2 className="w-full text-balance text-[40px] font-medium leading-[1.1] tracking-tighter text-white sm:text-5xl sm:leading-[1.1] lg:text-[56px] lg:leading-[1.1]">
              {blog.name}
            </h2>
          </div>
          <div className="absolute inset-0 z-[1] h-full w-full bg-black/20" />
          <Image
            src={blog?.image?.url ?? '/images/placeholder.png'}
            alt={resolveImageAlt(blog?.image, blog?.name)}
            width={0}
            height={0}
            priority
            loading="eager"
            sizes="100vw"
            className="absolute inset-0 z-0 h-full w-full object-cover object-center"
          />
        </div>
      </section>
    </>
  );
}
